<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">单页设置</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="30px" class="user-search">
            <el-form-item label=" ">
                <el-button size="small" type="primary" @click="addClick">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" highlight-current-row border  style="width: 100%;">
        <el-table-column  prop="remark" label="备注" >
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="cValue" label="内容" >
        </el-table-column>
            <el-table-column align="center" label="操作" >
                <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleEdit(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->

        <el-dialog :visible.sync="editFormVisible" width="40%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="备注">
                    <el-input el-input size="small" v-model="editForm.remark" auto-complete="off" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="标识" >
                    <el-input el-input size="small" :disabled="editFlag" v-model="editForm.key" auto-complete="off" placeholder="请输入标识"></el-input>
                </el-form-item>
            </el-form>
            <quill-editor
                :content="content"
                :options="editorOption"
                @change="onEditorChange($event)"
            />
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
    
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Pagination from '../../components/Pagination'
import { loadConfigList , updateConfig , createConfig } from '../../api/userMG'
export default {
    data () {
        return {
            loading:false,
            rules:{},
            editFlag:false,
            editForm:{
                remark:'',
            },
            editFormVisible:false,
            content: '<h2>I</h2><p>这是射，么就卡奇我觉额定</p><p>啊索拉卡到家啊了肯定</p><p>接口</p>',
            editorOption: {
            // Some Quill options...
            },
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                nickName: '',
            },
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    components: {
        quillEditor,
        Pagination
    },
    created(){
        this.getdata()
    },
    methods: {
        addClick(){
            this.editFlag = false
            this.editFormVisible = true
            this.editForm.remark = ''
            this.content = ''
        },  
        submitForm(){
            if(this.editForm.remark == ''){
                this.$message({
                  type: 'error',
                  message: '备注不能为空'
                })
            }else{
                if(this.editFlag == true){
                    updateConfig({
                        id:this.editForm.id,
                        remark:this.editForm.remark,
                        value:this.content
                    }).then(res=>{
                        this.editFormVisible = false
                        this.getdata()
                        this.$message({
                            type: 'success',
                            message: '修改成功'
                        })
                    })
                }else {
                    if(this.editForm.key == ''){
                        this.$message({
                            type: 'error',
                            message: '标识不能为空'
                        })
                    }else{
                        createConfig({
                            remark:this.editForm.remark,
                            value:this.content,
                            key:this.editForm.key,
                            type:2
                        }).then(res=>{
                            this.editFormVisible = false
                            this.getdata()
                            this.$message({
                                type: 'success',
                                message: '新增成功'
                            })
                        })
                    }
                }
            }
        },  

        onEditorChange({ quill, html, text }) {
            console.log(html)
            this.content = html
        },
        handleEdit(row){
            console.log(row)
            this.editFlag = true
            this.editForm.remark = row.remark
            this.editForm.key = row.cKey
            this.editForm.id = row.id
            this.content = row.cValue
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        getdata(){
            loadConfigList({type:2}).then(res=>{
                this.listData = res.configs
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    },
    computed: {
		editor() {
			return this.$refs.myQuillEditor.quill
		}
    },
    mounted() {
    // console.log('this is current quill instance object', this.editor)
    },
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/system/SinglePage.vue